import React, {useEffect} from 'react';
import {
   StyleSheet,
   SafeAreaView,
   Linking,
   Platform,
   BackHandler,
} from 'react-native';
import {appBackground, drawerListBackgroundColor} from '../../utils/utils';
import {useNavigation, useRoute} from '@react-navigation/native';
import {CustomStatusBar} from '../../utils/customStatusBar';
import CourseResourceView from './CourseResourcesView';
//import { CourseResourcePDFContainer } from './CourseResourcePDFContainer';
import logger from '../../utils/logger';
import {useDispatch} from 'react-redux';
import {setIsEnrolledPageReload} from '../../redux/slices/EnrolledCourseDataSlice';

function navigateToWebView(
   path,
   isShowingByBase64Str,
   sharingEnabled,
   navigation,
) {
   if (Platform.OS === 'windows' || Platform.OS === 'macos') {
      navigation.navigate('WebViewContainerMacos', {
         urlPath: path,
         isShowingByBase64Str: false,
         sharingEnabled: false,
      });
   } else {
      navigation.navigate('WebViewContainer', {
         urlPath: path,
         isShowingByBase64Str: isShowingByBase64Str,
         sharingEnabled: sharingEnabled,
         title: 'Course Resource',
      });
   }
}

export const CourseResourceContainer = props => {
   const navigation = useNavigation();
   const resources = useRoute().params;
   logger('resources= ' + JSON.stringify(resources));
   const isAndroid = Platform.OS === 'android';
   const isWindows = Platform.OS === 'windows';
   return (
      <SafeAreaView
         style={[
            styles.container,
            {
               ...Platform.select({
                  web: {
                     flex: null,
                     height: '100vh',
                  },
               }),
            },
         ]}>
         <CustomStatusBar
            backgroundColor={drawerListBackgroundColor}
            barStyle="light-content"
         />
         <CourseResourceView
            resourcesList={resources}
            onRowSelected={urlPath => {
               logger('URLPATH:' + urlPath);
               if (isAndroid && urlPath.endsWith('.pdf')) {
                  Linking.openURL(
                     'https://docs.google.com/gview?embedded=true&url=' +
                        urlPath,
                  );
               } else if (isWindows) {
                  Linking.openURL(urlPath);
               } else {
                  navigateToWebView(urlPath, false, false, navigation);
               }
            }}
            navigation={navigation}
         />
      </SafeAreaView>
   );
};

const styles = StyleSheet.create({
   container: {
      flex: 1,
      backgroundColor: drawerListBackgroundColor,
   },
});
